import { useState } from "react";
import { useModalStore } from "../../../stores/modalStore.js";
import { useServerStore } from "../../../stores/serverStore.js";

export default function CreateServerModal() {
  const { isOpen, type, onClose } = useModalStore();
  const { addServer, setCurrentServer } = useServerStore();
  const [serverName, setServerName] = useState("");
  const [serverIcon, setServerIcon] = useState("🎮");
  const [mode, setMode] = useState("create"); // 'create' or 'join'
  const [joinCode, setJoinCode] = useState("");

  if (!isOpen || type !== "createServer") return null;

  const handleCreate = () => {
    if (!serverName.trim()) return;

    const newServer = {
      id: `server-${Date.now()}`,
      name: serverName,
      icon: serverIcon,
      description: `${serverName} community server`,
      active: false,
    };

    addServer(newServer);
    setCurrentServer(newServer.id);
    setServerName("");
    onClose();
  };

  const handleJoin = () => {
    if (!joinCode.trim()) return;
    // In a real app, this would validate the code against a backend
    alert("Joining server with code: " + joinCode);
    setJoinCode("");
    onClose();
  };

  return (
    <div className="modal-overlay fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div
        className="modal-content bg-[#1a1a1a] border border-[#2a2a2a] rounded-lg p-8 w-full max-w-md max-h-96 overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-white">Create or Join Server</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-2xl">
            ✕
          </button>
        </div>

        {/* Mode Tabs */}
        <div className="flex gap-2 mb-6">
          <button
            onClick={() => setMode("create")}
            className={`flex-1 py-2 rounded font-medium transition ${
              mode === "create"
                ? "bg-blue-600 text-white"
                : "bg-[#2a2a2a] text-gray-400 hover:text-white"
            }`}
          >
            Create
          </button>
          <button
            onClick={() => setMode("join")}
            className={`flex-1 py-2 rounded font-medium transition ${
              mode === "join"
                ? "bg-blue-600 text-white"
                : "bg-[#2a2a2a] text-gray-400 hover:text-white"
            }`}
          >
            Join
          </button>
        </div>

        {/* Create Server Tab */}
        {mode === "create" && (
          <div className="space-y-4">
            <div>
              <label className="text-sm text-gray-400">Server Icon</label>
              <div className="flex gap-2 mt-2 flex-wrap">
                {["🎮", "⚔️", "🎯", "🚀", "💎", "👑", "🏰", "⭐", "🌟", "🔥"].map((icon) => (
                  <button
                    key={icon}
                    onClick={() => setServerIcon(icon)}
                    className={`text-2xl p-2 rounded transition ${
                      serverIcon === icon ? "bg-blue-600 scale-110" : "bg-[#2a2a2a] hover:bg-[#3a3a3a]"
                    }`}
                  >
                    {icon}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="text-sm text-gray-400">Server Name</label>
              <input
                type="text"
                value={serverName}
                onChange={(e) => setServerName(e.target.value)}
                placeholder="My Awesome Server"
                className="w-full bg-[#0f0f0f] border border-[#2a2a2a] rounded px-3 py-2 text-white mt-1 focus:outline-none focus:border-blue-500"
              />
            </div>

            <button
              onClick={handleCreate}
              disabled={!serverName.trim()}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-[#2a2a2a] disabled:text-gray-600 text-white font-medium py-2 rounded transition"
            >
              Create Server
            </button>
          </div>
        )}

        {/* Join Server Tab */}
        {mode === "join" && (
          <div className="space-y-4">
            <div>
              <label className="text-sm text-gray-400">Invite Link or Code</label>
              <input
                type="text"
                value={joinCode}
                onChange={(e) => setJoinCode(e.target.value)}
                placeholder="aethex-connect/abc123xyz"
                className="w-full bg-[#0f0f0f] border border-[#2a2a2a] rounded px-3 py-2 text-white mt-1 focus:outline-none focus:border-blue-500"
              />
            </div>

            <p className="text-xs text-gray-500">
              You'll need an invite link or code from a server admin to join a server.
            </p>

            <button
              onClick={handleJoin}
              disabled={!joinCode.trim()}
              className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-[#2a2a2a] disabled:text-gray-600 text-white font-medium py-2 rounded transition"
            >
              Join Server
            </button>
          </div>
        )}

        {/* Cancel */}
        <button
          onClick={onClose}
          className="w-full mt-4 bg-[#2a2a2a] hover:bg-[#3a3a3a] text-white font-medium py-2 rounded transition"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
